const columns = [
  {
    headerLabel: 'higherAdjustments.ranking',
    type: 'numeral',
    field: 'ranking',
    className: 'small-column',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'higherAdjustments.date',
    type: 'general',
    field: 'date',
    className: 'align-left',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'higherAdjustments.store',
    type: 'general',
    field: 'listRegionsAndBranchs',
    className: 'align-left',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'higherAdjustments.section',
    type: 'general',
    field: 'cdSection',
    className: 'align-left',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'higherAdjustments.cdLm',
    type: 'general',
    field: 'cdLm',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'higherAdjustments.description',
    type: 'general',
    field: 'description',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.c50',
    type: 'decimalC50',
    field: 'c50',
    className: 'align-right',
    render: true,
    fixed: false,
    canBeNegative: true,
  },
  {
    headerLabel: 'rotativeInventory.c50Counted',
    type: 'decimal',
    field: 'c50CountedB',
    className: 'align-right',
    render: true,
    fixed: false,
    canBeNegative: true,
  },
  {
    headerLabel: 'higherAdjustments.qqt.adjust',
    type: 'decimal_text',
    field: 'qqtAdjust',
    className: '',
    render: true,
    fixed: false,
    canBeNegative: true,
  },
  {
    headerLabel: 'higherAdjustments.total',
    type: 'currency',
    field: 'total',
    className: 'align-left',
    render: true,
    fixed: false,
    canBeNegative: true,
  },
  {
    headerLabel: 'rotativeInventory.integrated',
    type: 'general',
    field: 'integrated',
    className: 'small-column align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.dsJustification',
    type: 'general',
    field: 'dsJustification',
    className: 'align-left',
    render: true,
    fixed: false,
  },
]

export default columns
